import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import '../ServiceList/ServiceList.css';
import MenuItem from '@mui/material/MenuItem';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import { fetchHookList, deleteHook } from '../../store/app/apis';
import Toast from 'light-toast';
import CreateHook from '../CreateHook/CreateHook';
import { getTime } from '../../utils';
import SendHook from '../SendHook/SendHook';
import TablePagination from '@mui/material/TablePagination';
import MailIcon from '@mui/icons-material/Mail';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function HookList({ hookList, hookCount, fetchHookList, deleteHook }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [menuAnchorEl, setmenuAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [page, setPage] = useState(0);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const open = Boolean(menuAnchorEl);
  const [id, setId] = useState('');
  const handleClick = (event, id) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setmenuAnchorEl(null);
    setId(id);
  };
  const handleClick1 = (event, id) => {
    setAnchorEl1(anchorEl1 ? null : event.currentTarget);
    setmenuAnchorEl(null);
    setId(id);
  };
  const handleMenu = (event, id) => {
    setmenuAnchorEl(event.currentTarget);
    setId(id);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleDialog = () => {
    setmenuAnchorEl(null);
    setOpenConfirmationDialog(true);
  };

  const handleClose = (issuccess) => {
    setOpenConfirmationDialog(false);
    if (issuccess) {
      deleteHook(id);
    }
  };
  const styles = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const copyToClipboard = (text) => {
    if (typeof text === 'object') text = JSON.stringify(text);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        Toast.success('Copied!', 1000);
        setmenuAnchorEl(null);
      })
      .catch((error) => {
        Toast.fail('Text not copied!');
        setmenuAnchorEl(null);
      });
  };

  useEffect(() => {
    var payload = {};
    payload['page'] = page + 1;
    payload['size'] = rowsPerPage;
    fetchHookList(payload);
  }, [page, rowsPerPage]);

  return (
    <>
      <div className="completeTable">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Hook Name</th>
              <th>CT</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {hookList?.map((hook) => (
              <tr key={hook?.id}>
                <td style={{ textAlign: 'left', paddingLeft: '25px' }}>{hook?.name}</td>
                <td>{getTime(hook?.ct)} </td>
                <td>
                  <MoreVertIcon onClick={(event) => handleMenu(event, hook?.id)} sx={{ cursor: 'pointer' }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Menu
          id="profile-item-menu"
          anchorEl={menuAnchorEl}
          onClose={() => setmenuAnchorEl(null)}
          open={open}
          variant="selectedMenu"
        >
          <MenuItem value={10}>
            <button onClick={() => handleDialog()} className="iconsText">
              <DeleteIcon />
              Delete
            </button>
          </MenuItem>
          <MenuItem value={20}>
            <button onClick={(event) => handleClick(event, id)} className="iconsText">
              <EditIcon />
              Edit
            </button>
          </MenuItem>
          <MenuItem value={30}>
            <button
              onClick={() => copyToClipboard(hookList?.filter((hook) => hook.id === id)[0]['id'])}
              className="iconsText"
            >
              <ContentCopyIcon />
              copy
            </button>
          </MenuItem>
          <MenuItem value={40}>
            <button onClick={(event) => handleClick1(event, id)} className="iconsText">
              <MailIcon />
              send email
            </button>
          </MenuItem>
        </Menu>
        {anchorEl && <CreateHook anchorEl={anchorEl} id={id} onClose={handleClick} />}
        {anchorEl1 && <SendHook anchorEl={anchorEl1} id={id} onClose={handleClick1} />}
        <TablePagination
          rowsPerPageOptions={[10, 15, 25, 50, 100]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          count={hookCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          sx={styles}
        />
        {openConfirmationDialog && <ConfirmationDialog closedialog={handleClose} />}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  hookList: state.app.hookList,
  hookCount: state.app.hookCount,
});
const mapDispatchToProps = { fetchHookList, deleteHook };

export default connect(mapStateToProps, mapDispatchToProps)(HookList);
